export default __webpack_public_path__ + "static/media/chat-logo.6f965ece.png";